<template>
  <div class="bg__container">
    <div :class="['bg__wrapper', { secondary: data.gridType === 'Secondary' }]">
      <div :class="[{ bg__item: data.gridType === 'Primary' }]" v-for="(article, index) in filteredItem" :key="index">
        <GridPrimary v-if="data.gridType === 'Primary'" :article="article" />
        <GridSecondary v-else :article="article" />
      </div>
    </div>
    <button v-if="checkLimit" class="bg__load-more" @click="increaseLimit()">Load More</button>
  </div>
</template>

<script setup>
  import { ref, computed, onMounted } from 'vue';
  import GridPrimary from './components/grid-primary.vue';
  import GridSecondary from './components/grid-secondary.vue';

  const props = defineProps({
    data: {
      type: Array,
      required: true,
    },
  });

  onMounted(() => {
    window.addEventListener('resize', () => {
      windowWidth.value = window.innerWidth;
    });
  });

  var windowWidth = ref(window.innerWidth);
  var mobileLimit = props.data.gridType === 'Secondary' ? ref(6) : ref(4);
  var desktopLimit = ref(6);

  const articles = computed(() => {
    return props.data.articles.slice(0, props.data.articleLimit);
  });

  const filteredItem = computed(() => {
    return articles.value.slice(0, windowWidth.value > 1023 ? desktopLimit.value : mobileLimit.value);
  });

  const checkLimit = computed(() => {
    return windowWidth.value > 1023
      ? desktopLimit.value < articles.value.length
      : mobileLimit.value < articles.value.length;
  });

  function increaseLimit() {
    if (windowWidth.value > 1023) {
      desktopLimit.value = desktopLimit.value + 6;
    } else {
      if (props.data.gridType === 'Secondary') {
        mobileLimit.value = mobileLimit.value + 6;
      } else {
        mobileLimit.value = mobileLimit.value + 4;
      }
    }
  }
</script>
